export default __webpack_public_path__ + "static/media/Substrates-Process.09a06c1d.png";